import { get } from 'lodash';

import { CHANNEL } from 'src/data/channel';

export const FEATURE_LIMITS = {
  customTonesOfVoicePerCustomer: 'custom_tones_of_voice_per_customer',
  audiencePersonasPerCustomer: 'audience_personas_per_customer',
  brandBriefPerCustomer: 'brand_brief_per_customer',
  customFormulasPerCustomer: 'custom_formulas_per_customer',
  brandRulesPerCustomer: 'brand_rules_per_customer',
  workspacesPerCustomer: 'workspaces_per_customer',
  membersPerCustomer: 'members_per_customer',
  trustpilotReviewSitesPerCustomer: 'trustpilot_review_sites_per_customer',
  amazonReviewSitesPerCustomer: 'amazon_review_sites_per_customer',
  homePageWebsitesPerCustomer: 'home_page_websites_per_customer',
  landingPageWebsitesPerCustomer: 'landing_page_websites_per_customer',
  boostPerformancesPerCustomer: 'boost_performances_per_customer',
  plagiarismChecksPerCustomer: 'plagiarism_checks_per_customer',
};

export const getFeatureLimitsData = (customer, feature) => {
  const featureLimits = get(customer, 'featureLimits', []);
  return featureLimits.find((f) => f.name === feature);
};

const FEATURE_LIMITS_PROPS = {
  [FEATURE_LIMITS.customTonesOfVoicePerCustomer]: {
    label: 'Tones of Voice',
  },
  [FEATURE_LIMITS.audiencePersonasPerCustomer]: {
    label: 'Target Audiences',
  },
  [FEATURE_LIMITS.brandBriefPerCustomer]: {
    label: 'Messaging Bank assets',
  },
  [FEATURE_LIMITS.customFormulasPerCustomer]: {
    label: 'Custom Formulas',
  },
  [FEATURE_LIMITS.brandRulesPerCustomer]: {
    label: 'Brand Rules',
  },
  [FEATURE_LIMITS.workspacesPerCustomer]: {
    label: 'Workspaces',
  },
  [FEATURE_LIMITS.membersPerCustomer]: {
    label: 'Members',
  },
  [FEATURE_LIMITS.trustpilotReviewSitesPerCustomer]: {
    label: 'Trustpilot review page',
  },
  [FEATURE_LIMITS.amazonReviewSitesPerCustomer]: {
    label: 'Amazon review page',
  },
  [FEATURE_LIMITS.homePageWebsitesPerCustomer]: {
    label: 'Homepage',
  },
  [FEATURE_LIMITS.landingPageWebsitesPerCustomer]: {
    label: 'Landing Page',
  },
  [FEATURE_LIMITS.boostPerformancesPerCustomer]: {
    label: 'Performance Boosts',
  },
  [FEATURE_LIMITS.plagiarismChecksPerCustomer]: {
    label: 'Plagiarism Checks',
  },
};

export const getFeatureLimitsLabel = (feature) => FEATURE_LIMITS_PROPS[feature]?.label;

export const getPerformanceFeatureLimitsFromChannel = (channel) => {
  switch (channel) {
    case CHANNEL.trustpilot:
      return FEATURE_LIMITS.trustpilotReviewSitesPerCustomer;
    case CHANNEL.amazon:
      return FEATURE_LIMITS.amazonReviewSitesPerCustomer;
    case CHANNEL.homepage:
      return FEATURE_LIMITS.homePageWebsitesPerCustomer;
    case CHANNEL.landingPages:
      return FEATURE_LIMITS.landingPageWebsitesPerCustomer;
    default:
      return null;
  }
};

export const featureHasUsages = (featureData) => {
  if (!featureData || !featureData.limit) {
    return true;
  }
  return (featureData.currentCount || 0) < featureData.limit;
};
